import { createRouter, createWebHistory } from 'vue-router'
import processingvV2 from '../views/ProcessingV2.vue'
import NotificationManagementView from '../views/NotificationManagementView'
import DashboardShell from '../views/DashboardShell.vue'
import CommandCenter from '../views/CommandCenter.vue'
import DashboardViewV2 from '../views/DashboardViewV2.vue'


import PostCloseConnect from '../views/PostCloseConnect.vue'
import PostCloseConnectV2 from '../views/PostCloseConnectV2.vue'
import ApplicationsView from '../views/ApplicationsView'
import CondtionCommandView from '../views/ConditionCommand.vue'
import ConditionMain from '../components/conditionCommand/ConditionsDashboardMain.vue'
import Insights from '@/views/Insights.vue'
import RepricedLocksDashboard from '@/views/RepricedLocksDashboard.vue'
import RepriceApproval  from '@/views/Repriceapproval.vue'
import HmdaWithdrawalDashboard from '@/views/HmdaWithdrawalDashboard.vue'
import FhaMipPaymentsDashboard from '@/views/FhaMipPaymentsDashboard.vue'
import AiInsuringDashboard from '@/views/AiInsuringDashboard.vue'
import ReverseMortgageView from '@/views/ReverseMortgageView.vue'
import LockExtensionsDashboard from '@/views/LockExtensionsDashboard.vue'
import LockExtensionLanding from '@/views/LockExtensionLanding.vue'
import LoanPriceSheet from '@/views/LoanPriceSheet.vue'
import LockDeskQueue from '@/views/LockDeskQueue.vue'
import Concessions from '@/views/Concessions.vue'
import InitialDisclosureDashboard from '@/views/InitialDisclosureDashboard.vue'
import InsuringView from '@/views/InsuringView.vue'
const routes = [
    {
    path: '/ICD',
    name: 'initialDisclosures',
    component: InitialDisclosureDashboard
  },
  {
    path: '/loan-price-sheet',
    name: 'LoanPriceSheet',
    component: LoanPriceSheet
  },
  {
    path: '/lock-extension-request',
    name: 'LockExtensionLanding',
    component: LockExtensionLanding
  },
  {
    path: '/lock-desk-queue',
    name: 'lockDeskQueue',
    component: LockDeskQueue
  },
  {
    path: '/concessions',
    name: 'concessions',
    component: Concessions
  },
  {
    path: '/extensions',
    name: 'extensions',
    query: { id: '' },
    component: LockExtensionsDashboard
  },
  {
    path: '/reprice',
    name: 'reprice',
    query: { id: '' },
    component: RepricedLocksDashboard
  },
   {
    path: '/reprice-approval',
    name: 'repriceApproval',
    component: RepriceApproval
  },
  {
    path: '/processing',
    name: 'processing',
    query: { id: '' },
    component: processingvV2
  },
  {
    path: '/Processingv2',
    name: 'processingv2',
    query: { id: '' },
    component: processingvV2
  },
  {
    path: '/NotificationManagement',
    name: 'notificationManagement',
    component: NotificationManagementView
  },


  {
    path: '/',
    name: 'dashboard',
    component: DashboardShell
  },
  {
    path: '/commandcenter',
    name: 'commandcenter',
    component: CommandCenter
  },
  {
    path: '/dashboardv2',
    name: 'dashboardv2',
    component: DashboardViewV2
  }, 
  {
    path: '/PostCloseConnect',
    name: 'postCloseConnect',
    component: PostCloseConnectV2
  },
  {
    path: '/PostCloseConnectV2',
    name: 'postCloseConnectV2',
    component: PostCloseConnectV2
  },
  {
    path: '/Applications',
    name: 'applications',
    component: ApplicationsView
  },
  {
    path: '/ConditionCommand',
    name: 'condtionCommand',
    component: CondtionCommandView
  },
  {
    path: '/ConditionMain',
    name: 'ConditionMain',
    component: ConditionMain
  },
  ,
  {
    path: '/Insights',
    name: 'Insights',
    component: Insights
  },
  {
    path: '/hmda-withdrawals',
    name: 'hmdaWithdrawals',
    component: HmdaWithdrawalDashboard
  },
  {
    path: '/fha-mip-payments',
    name: 'fhaMipPayments',
    component: FhaMipPaymentsDashboard
  },
  {
    path: '/ai-insuring',
    name: 'aiInsuring',
    component: AiInsuringDashboard
  },
  {
    path: '/reverse-mortgage',
    name: 'reverseMortgage',
    component: ReverseMortgageView
  },
  {
    path: '/Insuring',
    name: 'insuring',
    component: InsuringView
  },
  {
  path: '/application-commercial',
  name: 'CommercialLoan',
   component: () => import('../views/CommercialLoanView.vue'),
   meta: { requiresAuth: true }
 }
 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router
